import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@unite-us/ui';
var RemovePhoneButton = function RemovePhoneButton(_ref) {
  var styles = _ref.styles,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: "remove-phone-button"
  }, /*#__PURE__*/React.createElement("button", {
    className: "remove-phone-button__link mt-half text-s,",
    onClick: onClick,
    type: "button",
    style: styles.linkStyle,
    title: "Remove phone number"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconTrash",
    style: styles.iconStyle
  })));
};
RemovePhoneButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  styles: PropTypes.shape({
    linkStyle: PropTypes.object,
    iconStyle: PropTypes.object
  })
};
RemovePhoneButton.defaultProps = {
  styles: {
    linkStyle: {
      display: 'block'
    },
    iconStyle: {
      svg: {
        width: '1.5em',
        height: '1.5em'
      }
    }
  }
};
export default RemovePhoneButton;
//# sourceMappingURL=RemovePhoneButton.js.map